import { AlertModalEnum } from "@/enums/common/alert-modal.enum"
import Cookies from 'quasar/src/plugins/Cookies.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';

const prefix = 'ModalClosed'

const defaultOptions = {
    expires: '24h'
}

export const clearAlertModalState = (parameter: AlertModalEnum) => {
    if (!navigator.cookieEnabled) {
        if (SessionStorage.has(`${prefix}_${parameter}`)) {
            SessionStorage.remove(`${prefix}_${parameter}`)
        }
    } else {
        if (Cookies.has(`${prefix}_${parameter}`)) {
            Cookies.remove(`${prefix}_${parameter}`)
        }
    }
}

export const shouldDisplayAlertModal = (parameter: AlertModalEnum) => {
    let shouldOpenThisModal = false
    if (!navigator.cookieEnabled) {
        shouldOpenThisModal = !(SessionStorage.getItem(`${prefix}_${parameter}`))
    } else {
        const hasIt = Cookies.has(`${prefix}_${parameter}`)
        if (!hasIt) {
            shouldOpenThisModal = true 
        }
    }

    return shouldOpenThisModal 
}

export const setAlertModalClosed = (parameter: AlertModalEnum) => {
    if (!navigator.cookieEnabled) {
        SessionStorage.set(`${prefix}_${parameter}`, true);
    } else {
        Cookies.set(`${prefix}_${parameter}`, 'true', defaultOptions)
    }
}